import {Row} from "react-bootstrap";
import React from "react";
import './MailUtil.css';
import {mailLink, portfolioData} from "../../../data/data";

const MailUtil = () => <Row className={'flex-column social'} style={{left:'auto', right:'40px'}}>
    <div className="mail">
        <div className="mail-text">
            <a href={mailLink}>{portfolioData.email}</a>
        </div>
    </div>
</Row>;

export default MailUtil;